import asignaturas from '@/api/cifra/asignaturas';
import { Controller } from '@hotwired/stimulus';
import { isEmpty } from 'lodash';

/**
 * Componente que gestiona un select de asignaturas. Se encarga de llamar al servidor
 * para cargar las asignaturas necesarias según la configuración.
 * Normalmente se utilizará junto a un selector de estructura y se encargará
 * de ir actualizando las asignaturas a medida que van cambiando
 */
export default class extends Controller {
  connect() {
    const selectorEstructuraQuery = this.element.dataset.selectorEstructura;
    this.labelBlanco = this.element.dataset.labelBlanco || '';
    // Estructura escolar de inicio
    this.seleccionInicial = this.element.dataset.seleccionInicial;
    this.valorInicial = this.element.dataset.valorInicial?.toString();

    if (selectorEstructuraQuery) {
      this.selectorEstructura = document.querySelector(selectorEstructuraQuery);
      this.#conectarSelectorEstructura();
    }
    if (this.seleccionInicial) {
      this.cargarAsignaturas(JSON.parse(this.seleccionInicial));
    }
  }

  limpiarSelect() {
    this.element.innerText = null;
    const option = document.createElement('option');
    option.text = this.labelBlanco;
    option.value = '';
    this.element.add(option);
  }

  cargarAsignaturas(filtros) {
    this.limpiarSelect();

    if (isEmpty(filtros)) {
      return;
    }

    const params = {
      inferiores: true,
      superiores: false,
      ...filtros,
    };

    asignaturas.list(params).then((result) => {
      const { data } = result;

      data.forEach((asignatura) => {
        const option = document.createElement('option');
        option.text = asignatura.nombre;
        option.value = asignatura.id;
        if (this.valorInicial === asignatura.id.toString()) {
          option.selected = true;
        }
        this.element.add(option);
      });
    });
  }

  #conectarSelectorEstructura() {
    if (!this.selectorEstructura) {
      return;
    }

    this.selectorEstructura.addEventListener('change', (event) => {
      const params = {};
      const { selectedPath } = event.detail;
      selectedPath?.forEach((path) => {
        params[`${path.type}_id`] = path.id;
      });
      this.cargarAsignaturas(params);
    });
  }
}
